var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5C13.0376 4.5 15.5 6.96243 15.5 10C15.5 13.0376 13.0376 15.5 10 15.5C6.96243 15.5 4.5 13.0376 4.5 10C4.5 6.96243 6.96243 4.5 10 4.5ZM9.39941 6.74121C9.24894 6.74121 9.13181 6.86919 9.13965 7.0166C9.18379 7.84724 9.21286 8.55382 9.22656 9.22754C8.79141 9.21966 8.33993 9.20635 7.84863 9.18359L7.01758 9.13965C6.86989 9.13115 6.74129 9.24844 6.74121 9.39941V10.5996C6.74144 10.7517 6.87201 10.8695 7.02051 10.8594C7.85582 10.8026 8.56267 10.7696 9.22852 10.7568C9.22072 11.1971 9.20663 11.6538 9.18359 12.1514L9.13965 12.9834C9.13154 13.1308 9.24866 13.2587 9.39941 13.2588H10.5996C10.7515 13.2586 10.8691 13.1288 10.8594 12.9805C10.8022 12.1407 10.7695 11.4306 10.7568 10.7617C11.4361 10.7783 12.146 10.8122 12.9834 10.8604C13.1307 10.8685 13.2583 10.7519 13.2588 10.6016V9.39941C13.2588 9.26778 13.1612 9.16182 13.0381 9.14258L12.9844 9.13965C12.1489 9.18406 11.439 9.21296 10.7617 9.22656C10.7784 8.5526 10.8126 7.84777 10.8604 7.01758C10.8688 6.87 10.7521 6.74167 10.6016 6.74121H9.39941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3707545eec48be7c541161de5e4b8a06.svg";
export { ForwardRef as ReactComponent };